module.exports = __webpack_public_path__ + "img/youtube-monochrome.e354d7c5.svg";